import { render, staticRenderFns } from "./DashChartDemo.vue?vue&type=template&id=14cf40b5&"
import script from "./DashChartDemo.vue?vue&type=script&lang=js&"
export * from "./DashChartDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports